<footer>
  <mat-toolbar>
    <mat-grid-list cols="12" rowHeight="50px">
      <mat-grid-tile colspan="6" class="copyright">
        <span>&copy;</span>
        <p> 2021 - Staatsanzeiger für Baden-Württemberg GmbH &amp; Co. KG </p>
      </mat-grid-tile>
      <mat-grid-tile colspan="6">
        <a href="https://www.staatsanzeiger.de/impressum" target="_blank">Impressum</a>
        <a href="https://www.staatsanzeiger.de/datenschutz" target="_blank">Datenschutz</a>
        <a href="https://www.staatsanzeiger.de/agb" target="_blank">AGB</a>
      </mat-grid-tile>
    </mat-grid-list>
  </mat-toolbar>
</footer>
